import { Node, nodeInputRule, ReactNodeViewRenderer } from '@tiptap/react'
import { Plugin, PluginKey } from 'prosemirror-state'
import { AudioNode } from './audio-node'

export interface AudioOptions {
  HTMLAttributes: Record<string, any>
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    audio: {
      /**
       * Set a audio node
       */
      setAudio: (src: string) => ReturnType
    }
  }
}

const AUDIO_INPUT_REGEX = /!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\)/

export const Audio = Node.create({
  name: 'audio',
  draggable: true,
  group: 'block',

  addOptions() {
    return {
      uploadAudio: (v: any) => {},
    }
  },

  addAttributes() {
    return {
      src: {
        default: null,
        parseHTML: (el) => (el as HTMLSpanElement).getAttribute('src'),
        renderHTML: (attrs) => ({ src: attrs.src }),
      },
      source_id: {
        default: null,
        parseHTML: (el) => (el as HTMLSpanElement).getAttribute('source_id'),
        renderHTML: (attrs) => ({ source_id: attrs['source_id'] }),
      },
      controlsList: {
        default: 'nodownload',
        parseHTML: (el) => (el as HTMLSpanElement).getAttribute('controlsList'),
        renderHTML: (attrs) => ({ controlsList: attrs['controlsList'] }),
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'audio',
        getAttrs: (el) => ({
          src: (el as HTMLAudioElement).getAttribute('src'),
          source_id: (el as HTMLAudioElement).getAttribute('source_id'),
        }),
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'audio',
      { controls: 'true', borderRadius: 16, style: 'width: 100%', ...HTMLAttributes },
      ['source', HTMLAttributes],
    ]
  },

  addInputRules() {
    return [
      nodeInputRule({
        find: AUDIO_INPUT_REGEX,
        type: this.type,
        getAttributes: (match) => {
          const [, , src] = match

          return { src }
        },
      }),
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(AudioNode, {
      as: 'div',
      contentDOMElementTag: 'div',
      attrs: {
        ...this.options.HTMLAttributes,
      },
    })
  },
})
